<template>
  <div class="search-form">
    <el-form :model="searchData" class="search-form-grid">
      <!-- 第一行：4列 -->
      <el-row :gutter="16" class="search-row">
        <el-col :span="6" v-for="field in searchFields.slice(0, 4)" :key="field.key">
          <el-form-item class="search-form-item">
            <search-item 
              :label="field.label"
              :type="field.type"
              :placeholder="field.placeholder"
              :maxlength="field.maxlength"
              :options="field.options"
              :value="searchData[field.key]"
              @input="updateSearchData(field.key, $event)">
            </search-item>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 第二行：4列 -->
      <el-row :gutter="16" class="search-row">
        <el-col :span="6" v-for="field in searchFields.slice(4, 8)" :key="field.key">
          <el-form-item class="search-form-item">
            <search-item 
              :label="field.label"
              :type="field.type"
              :placeholder="field.placeholder"
              :maxlength="field.maxlength"
              :options="field.options"
              :value="searchData[field.key]"
              @input="updateSearchData(field.key, $event)">
            </search-item>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 第三行：2个字段 + 按钮 -->
      <el-row :gutter="16" class="search-row">
        <el-col :span="6" v-for="field in searchFields.slice(8, 10)" :key="field.key">
          <el-form-item class="search-form-item">
            <search-item 
              :label="field.label"
              :type="field.type"
              :placeholder="field.placeholder"
              :maxlength="field.maxlength"
              :options="field.options"
              :value="searchData[field.key]"
              @input="updateSearchData(field.key, $event)">
            </search-item>
          </el-form-item>
        </el-col>
        
        <!-- 按钮区域 -->
        <el-col :span="12" class="button-col">
          <div class="button-group">
            <el-button 
              size="medium" 
              type="primary" 
              @click="$emit('search')">搜索</el-button>
            <el-button 
              size="medium" 
              type="info" 
              @click="$emit('reset')">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import SearchItem from './SearchItem.vue'

export default {
  name: 'SearchForm',
  components: {
    SearchItem
  },
  props: {
    searchData: Object
  },
  data() {
    return {
      searchFields: [
        { key: 'gatewayId', label: '网关ID', type: 'input', placeholder: '请输入', maxlength: 50 },
        { key: 'name', label: '网关名称', type: 'input', placeholder: '请输入', maxlength: 50 },
        { key: 'scenarioName', label: '场景', type: 'input', placeholder: '请输入场景名称', maxlength: 50 },
        { key: 'modelName', label: '模型', type: 'input', placeholder: '请输入模型名称', maxlength: 50 },
        { key: 'groupId', label: '分组/ID', type: 'input', placeholder: '请输入分组名称/ID', maxlength: 50 },
        { key: 'nickname', label: '创建人', type: 'input', placeholder: '请输入创建人名称', maxlength: 50 },
        { key: 'phone', label: '手机号码', type: 'input', placeholder: '请输入', maxlength: 11 },
        { key: 'macAddr', label: '网关地址', type: 'input', placeholder: '请输入', maxlength: 50 },
        { key: 'createTime', label: '创建时间', type: 'daterange', placeholder: '' },
        { key: 'userId', label: '创建人ID', type: 'input', placeholder: '请输入创建人ID', maxlength: 50 }
      ]
    }
  },
  methods: {
    updateSearchData(key, value) {
      this.$emit('update:searchData', { ...this.searchData, [key]: value })
    }
  }
}
</script>

<style scoped>
.search-form {
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 16px;
}

.search-form-grid {
  margin: 0;
}

.search-row {
  margin-bottom: 8px;
}

.search-row:last-child {
  margin-bottom: 0;
}

.search-form-item {
  margin-bottom: 0 !important;
}

.search-form-item >>> .el-form-item__content {
  line-height: 32px;
}

.button-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.button-group {
  display: flex;
  gap: 8px;
}

.button-group .el-button {
  height: 32px;
  padding: 8px 16px;
}

/* 确保搜索项宽度一致 */
.search-form >>> .search-item {
  width: 100%;
}

/* 调整输入框高度 */
.search-form >>> .el-input__inner,
.search-form >>> .el-select .el-input__inner,
.search-form >>> .el-date-editor .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.search-form >>> .el-input__icon {
  line-height: 32px;
}

.search-form >>> .el-date-editor {
  width: 100%;
}
</style>